<h1 class="soft-text-xl mt-4 mb-2 ml-2 mr-2 border-box">Materialien</h1>
<div class="scrollable">
  <div  class="soft-list">
    @for (material of beweaus; track material.id) {
      <div class="soft-list-item c row space-between center-v no-wrap">
        <div class="grid no-wrap outlined mt-1">
          <div class="grid-row center-v extended span-full">
            <div class="c row space-between">
              <div class="c column pl-1 pr-2 pt-1 pb-1">
                <span class="soft-overline color-tertiary">{{ material?.artstamm?.cartikelnummer }}</span>
                <strong style="margin-top: 1px;">{{ material?.artstamm?.artbez1 }}</strong>
              </div>
            </div>
            @if (material?.legierung) {
              <span class="soft-text mr-2">{{ material?.legierung || '' }}</span>
            }
          </div>

          <div class="grid-row extended">
            <span></span>
            <strong class="soft-overline">Plan</strong>
            <strong class="soft-overline">Buch</strong>
            <strong class="soft-overline">Diff</strong>
            <strong class="soft-overline text-cell ml-5">Einheit</strong>
          </div>

          <div class="grid-row extended">
            <span class="text-cell">Menge</span>
            <span>{{ (material?.menge ?? '') | number:'1.3-3' }}</span>
            <span>{{ (material?.buchmenge ?? '') | number:'1.3-3' }}</span>
            <span>{{ (material?.diffmenge ?? '') | number:'1.3-3'  }}</span>
            <span class="text-cell ml-5">{{ material?.arteh }}</span>
          </div>

          <div class="grid-row extended">
            <span class="text-cell">Gewicht</span>
            <span>{{ (material?.gewicht ?? '') | number:'1.3-3'  }}</span>
            <span>{{ (material?.buchgewicht ?? '') | number:'1.3-3'  }}</span>
            <span>{{ (material?.diffgewicht ?? '') | number:'1.3-3'  }}</span>
            <span class="text-cell ml-5">Gramm</span>
          </div>
        </div>
      </div>
    }
  </div>
</div>